<script lang="ts">
	import { authLoading, isSignedIn } from '@repo/sharedlib/src/stores/auth.store';
	import { cloudSyncStore } from '@repo/sharedlib/src/stores/cloud.sync.store';
	import Spinner from './spinner/spinner.svelte';

	// This component reactively displays the sync operation message
	// It updates automatically when cloudSyncStore.currentOperation changes
	// without closing/reopening the toast
	// Hide the toast when user is not signed in and auth is not loading
	$: shouldShow = $isSignedIn || $authLoading;
</script>

{#if shouldShow}
	<div class="flex items-center gap-2">
		<Spinner />
		<span>{$cloudSyncStore.currentOperation || 'Syncing your data...'}</span>
	</div>
{/if}
